export function  getUserId() {
  return sessionStorage.getItem("userid");
}
export function  getToken() {
  return sessionStorage.getItem("token");
}

export function  getLevel() {
  let level= sessionStorage.getItem("level");
  if(level<3){
    return true
  }
  return false

}



// WEBPACK FOOTER //
// ./src/utils/auth.js